import DisplayEntity from "components/PageBuilder/DisplayEntity";
import IndexWithSearchBar from "components/PageBuilder/IndexWithSearchBar";
import DeleteMenuOption from "components/TableMonitoring/Body/RowMenuListActions/DeleteMenuOption";
import EditMenuOption from "components/TableMonitoring/Body/RowMenuListActions/EditMenuOption";
import TableHeaderStatic from "components/TableMonitoring/Header/Static/TableHeaderStatic";
import TableMonitoring from "components/TableMonitoring";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { initializePatientMessages } from "redux/reducers/messagesReducer";
import MessagesTableRows from "./MessagesTableRows";
import TableRowStatic from "components/TableMonitoring/Body/TableRowStatic";
import { CommonTexts, messagesTexts } from "locale/es";
import MessageIcon from "@mui/icons-material/Message";
import Loader from "components/Loader/Loader";
import NoDataTableBody from "components/TableMonitoring/Body/NoDataTableBody";
import { Outlet } from "react-router-dom";
import { RolesManager } from "utils/RolesManager";
import { Box } from "@mui/material";
import DrawerHeader from "components/DrawerHeader";
import BreadCrumbs from "components/Breadcrumbs/Breadcrumbs";
import { useFilterContext } from "context/FilterContext";
import { useFilter } from "hooks/useFilter";
import FilterTable from "components/TableMonitoring/Toolbar/Filter";

const tableHeaders = [
  { name: "Fecha", value: "created" },
  { name: "Autor", value: "authorMessage" },
  { name: "Título", value: "title" },
  { name: "Mensaje", value: "message" },
  { name: "Leído", value: "visited" },
];

function Messages({ isDashboard }) {
  const { user } = useSelector(state => state.userAuthentication)
  const patient = useSelector(({ patient }) => patient);
  const { data, loading, error } = useSelector(({ messages }) => messages);

  const { selectedFilter, searchTerm } = useFilterContext();

  const adaptedTableHeaders = tableHeaders.map((header) => header.name);
  const { filteredData } = useFilter(data, adaptedTableHeaders);

  const dispatch = useDispatch();

  useEffect(() => {
    if (patient.user?.id && data?.length === 0) {
      dispatch(initializePatientMessages(patient.user?.id));
    }
  }, [patient.user?.id, dispatch]);

  if (loading) {
    return <Loader message={messagesTexts.LOADING} pt={32} />;
  }

  const containerStyles = patient.id ? { width: 350, mt: 2, mb: -2 } : { p: 2, m: 2, mx: { md: 10, lg: 30 } }

  return (
    <Box component="main" sx={ !isDashboard ? { flex: 1, p: 3, mb: 20 } : { mb: 20, mt: -4 }}>
      {!isDashboard && (
        <>
          <DrawerHeader />
          <BreadCrumbs
            name={CommonTexts.MESSAGES}
            icon={<MessageIcon sx={{ mr: 0.5 }} fontSize='inherit' />}
          />
          <Box sx={containerStyles}>
            <IndexWithSearchBar />
          </Box>
        </>
      )}
      <DisplayEntity entityId={patient.id}>
      <FilterTable data={data} tableHeaders={tableHeaders} />
        <TableMonitoring
          patientId={patient.id}
          tableHeader={
            <TableHeaderStatic
              tableHeaders={adaptedTableHeaders}
              entity={patient}
              canCreate={RolesManager.userIsProfessional(user.roles) && !isDashboard}
            />
          }
        >
          {data?.length > 0 &&
           (selectedFilter && !searchTerm ? data : filteredData).map((message) => (
              <TableRowStatic
                key={message.id}
                entity={message}
                loaded={!loading}
                actions={
                  <>
                    {RolesManager.userIsProfessional(user.roles) && !isDashboard && (
                      <>
                        <EditMenuOption entity={message} />
                        <DeleteMenuOption entityId={message.id} />
                      </>
                    )}
                  </>
                }
              >
                <MessagesTableRows message={message} />
              </TableRowStatic>
            ))}
        </TableMonitoring>
        {data?.length === 0 && (
          <NoDataTableBody
            entity={patient.id}
            noDataMessage={messagesTexts.NO_DATA}
          />
        )}
        {data?.length > 0 && filteredData?.length === 0 && searchTerm && (
          <NoDataTableBody
            entity={patient.id}
            noDataMessage={messagesTexts.NO_DATA_FILTERS}
          />
        )}
      </DisplayEntity>
      <Outlet />
    </Box>
  );
}

export default Messages;
